import { useState } from "react";
import { useActions } from "app/utils/hooks";
import { clearMediaState, fetchMedia } from "app/actions/media-library-data";
import { clearFilter } from "app/actions/filter";
import { FilterModel } from "app/models/FilterModel";
import { usePagination } from "app/utils/hooks/usePagination";

export const useSelectUploadedResourcesModel = () => {
  const mediaActions = useActions({ fetchMedia, clearMediaState, clearFilter });

  const mediaParams = {
    order: "desc",
    page: 1,
    perPage: 20,
  };
  const [query, setQuery] = useState(mediaParams);

  const filterHandler = (filters: FilterModel) => {
    const filteredQuery = { ...mediaParams, ...filters };
    setQuery(filteredQuery);
  };

  const { data, pending, sentryRef }: any = usePagination({
    initialParams: {
      ...query,
    },
    fetchData: (params, signal) => mediaActions.fetchMedia(params, signal),
    clearDataAction: () => {
      mediaActions.clearFilter();
      mediaActions.clearMediaState();
    },
    dependencies: [query],
  });

  return { data, pending, filterHandler, sentryRef };
};
